import { render, staticRenderFns } from "./AssetsWithTruckersReport.vue?vue&type=template&id=8c955cda"
import script from "./AssetsWithTruckersReport.vue?vue&type=script&lang=js"
export * from "./AssetsWithTruckersReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports